import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Keep old scan links working through the current registration/onboarding flow.
export default function ScanPage() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/register', search }} replace />;
}